import { Injectable } from '@angular/core';
import { Operation } from './operation';

@Injectable()
export class UndoRedoService {
  constructor() {}

  private _undoStack = new Array<Operation>();
  private _redoStack = new Array<Operation>();

  public get hasUndo() {
    return this._undoStack.length !== 0;
  }

  public get hasRedo() {
    return this._redoStack.length !== 0;
  }

  undo() {
    if (!this.hasUndo) {
      return;
    }

    const operation = this._undoStack.pop();
    if (operation) {
      operation.undoOperation();
      this._redoStack.push(operation);
    }
  }

  redo() {
    if (!this.hasRedo) {
      return;
    }

    const operation = this._redoStack.pop();
    if (operation) {
      operation.operation();
      this._undoStack.push(operation);
    }
  }

  doOperation(operation: Operation) {
    operation.operation();
    this._undoStack.push(operation);
    this._redoStack.length = 0;
  }
}
